import ButtonComponent from "../button/ButtonComponent";
import "./refreshButton.scss"

interface RefreshButtonProps {
    refresh: () => void;
    className?: string;
}

const RefreshButton = ({ refresh }: RefreshButtonProps) => {
    return (
        <ButtonComponent type="primary" onClick={refresh}>Refresh</ButtonComponent>
    );
}

export default RefreshButton;